import { Accordion } from "radix-ui";
import type { ComponentProps } from "react";
import { useCardContext } from "../../context/CardContext";

export function Root({ children }: ComponentProps<"div">) {
	const { openCards, onOpenCardsChange } = useCardContext();

	return (
		<Accordion.Root
			className="space-y-4"
			type="multiple"
			value={openCards}
			onValueChange={(cards) => onOpenCardsChange(cards)}
		>
			{children}
		</Accordion.Root>
	);
}
